const VDocument = () => import("../../components/raft_documents/Document.vue");
const DocumentForm = () =>
  import("../../components/raft_documents/DocumentForm.vue");
const DocumentListing = () =>
  import("../../components/raft_documents/DocumentListing.vue");

require("./css/document.css");

const uuidPattern =
  "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
const routes = [
  {
    path: "/raft/document/add",
    name: "DocumentAdd",
    component: DocumentForm,
    props: true,
  },
  {
    path: "/raft/document/:uuid(" + uuidPattern + ")",
    name: "VDocument",
    component: VDocument,
    props: true,
  },
  {
    path: "/raft/document/:uuid(" + uuidPattern + ")/view",
    name: "documentView",
    component: VDocument,
    props: true,
  },
  {
    path: "/raft/document/:uuid(" + uuidPattern + ")/edit",
    name: "DocumentEdit",
    component: DocumentForm,
    props: true,
  },
  {
    path: "/raft/document/:uuid(" + uuidPattern + ")/confirmations",
    name: "DocumentConfirmations",
    component: DocumentForm,
    props: true,
  },
  {
    path: "/raft/research-tools/document-library",
    alias: "/raft/research_tools/document_library",
    name: "document_library",
    component: DocumentListing,
    props: true,
  },
  {
    path: "/raft/research-tools/document-library/archived",
    alias: "/raft/research_tools/document_library/archived",
    name: "document_library_archived",
    component: DocumentListing,
    props: { archived: true },
  },
  {
    path: "/node/:groupId/document-library",
    alias: "/node/:groupId/view/documents",
    name: "group_document_library",
    component: DocumentListing,
    props: true,
  },
  {
    path: "/node/:groupId/document-library/archived",
    alias: "/node/:groupId/view/documents/archived",
    name: "group_document_library_archived",
    component: DocumentListing,
    props: (route) => ({ groupId: route.params.groupId, archived: true }),
  },
  {
    path: "/node/:groupId/document-library/add",
    alias: "/node/:groupId/view/documents/add",
    name: "group_document_add",
    component: DocumentForm,
    props: true,
  },
  {
    path: "/node/:groupId/document-library/clone/:uuid(" + uuidPattern + ")",
    alias: "/node/:groupId/view/documents/clone/:uuid(" + uuidPattern + ")",
    name: "group_document_clone",
    component: DocumentForm,
    props: true,
  },
];

const globalComponents = {};

export {
  routes as documentRoutes,
  globalComponents as documentGlobalComponents,
};
